import { useTranslation } from 'react-i18next';
import { Empty } from 'antd';
import Assets from 'assets/icons';
import classes from './EmptyRecycleBin.module.scss';

const EmptyRecycleBin = () => {
  const { t } = useTranslation();

  return (
    <Empty
      className={classes.emptyState}
      image={<Assets.TrashIcon className={classes.icon} />}
      description={<div>
        <div>{t('RecycleBin.emptyBin')}</div>
        <div>{t('RecycleBin.willBeHere')}</div>
      </div>}
    />
  );
};

export default EmptyRecycleBin;

